import { Directive, Input, HostListener } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ValidationService } from './services/validation.service';

/*
    Returns error if AccountName exists in db
*/

@Directive({
    selector: '[doesAccountNameExist]'
})
export class DoesAccountNameExistValidatorDirective  {

    @Input()
    doesAccountNameExist: AbstractControl;
    
    constructor(private validationService: ValidationService) {
    }

    @HostListener('focusout', ['$event.target'])
    onFocusout(target) {
        if (!this.doesAccountNameExist.errors) {
            this.validationService.doesUserNameExist(this.doesAccountNameExist.value).subscribe((output) => {
                if (output == true) {
                    this.doesAccountNameExist.setErrors({
                        "accountNameExists": true
                    });
                }                   
            });
        }
    }
}

